import { render, staticRenderFns } from "./menu-primary.vue?vue&type=template&id=78654228&scoped=true"
import script from "./menu-primary.vue?vue&type=script&lang=js"
export * from "./menu-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78654228",
  null
  
)

export default component.exports